<template>
  <div>
    <button-spinner v-if="!are_reports_empty && show_zip_button"
                    :loading="zipLoading"
                    class="ma-2 right"
                    variant="info"
                    @click="download_as_zip">
      <template v-slot:defaultText>
        <span>REPORTS TO ZIP</span>
      </template>
    </button-spinner>

    <!-- refresh is mixins method use to update all components -->
    <b-table :class="{'hidden-filters': !show_filter}"
             :current-page="currentPage"
             :fields="fields"
             :items="experiment_reports"
             :per-page="perPage"
             :sort-by="'states.date'"
             :sort-desc="true"
             head-variant="light"
             hover
             responsive
             striped>
      <template v-slot:top-row="{fields}">
        <proposal-filter :id="id"
                         v-model="experiment_reports"
                         :fields="fields"
                         :not-include-key="['actions', 'ordinalNumber']"/>
      </template>

      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage: perPage, currentPage: currentPage}"/>
      </template>

      <template v-slot:cell(experiment_report.states.date)="row">
        <span v-if="isReportSubmitted(row.item)">
          {{ row.item.experiment_report.states.date }}
        </span>
      </template>

      <template v-slot:cell(actions)="row">
        <base-material-design-icon-button v-if="!elevated"
                                          icon="assignment_late"
                                          title="Add experiment report"
                                          @click="go_to_experiment_report(row.item)"/>
        <action-download-pdf v-if="getAttachmentId(row.item)"
                             :customPdfLocation="getAttachmentId(row.item)"
                             :disabled="false"
                             customPdfTitle="Report PDF"/>
      </template>
    </b-table>
    <b-table-footer v-model="loading"
                    :current-page="currentPage"
                    :data-length="experiment_reports.length"
                    :header-size="footerSize"
                    :pagination="footerPagination"
                    :per-page="perPage"
                    @change-page="change_page">
      <template v-slot>
        <base-per-page-input v-model="perPage"/>
      </template>
    </b-table-footer>
  </div>
</template>

<script>
  import ButtonSpinner from '@/components/buttonSpinner';
  import BTableFooter from '@/components/BTableFooter';
  import ProposalFilter from '@/components/ProposalFilter';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import ActionDownloadPdf from '@/components/actions/ActionDownloadPdf';
  import BaseMaterialDesignIconButton from '@/components/base-components/base-icons/BaseMaterialDesignIconButton';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';

  export default {
    name: 'experiment_list',
    components: {
      ActionDownloadPdf,
      BaseColumnOrdinalNumber,
      BaseMaterialDesignIconButton,
      BasePerPageInput,
      ButtonSpinner,
      BTableFooter,
      ProposalFilter,
    },
    props: {
      load_data_url: {
        type: String,
        default: '',
      },
      prop_fields: {
        type: Array,
        default: () => [],
      },
      show_zip_button: {
        type: Boolean,
        default: false,
      },
      show_filter: {
        type: Boolean,
        default: true,
      },
      elevated: {
        type: Boolean,
        default: false,
      },
      footerPagination: {
        type: Boolean,
        default: true,
      },
      footerSize: {
        type: Number,
        default: 1,
        validator: (val) => [1, 2, 3, 4, 5, 6].includes(val),
      },
    },
    computed: {
      are_reports_empty() {
        return this.experiment_reports.length === 0;
      },
    },
    data() {
      return {
        id: 1,
        perPage: 20,
        loading: false,
        zipLoading: false,
        currentPage: 1,
        experiment_reports: [],
        fields: this.prop_fields,
      };
    },
    methods: {
      load_data() {
        this.loading = true;
        this.axios.get(this.load_data_url)
          .then((response) => {
            this.experiment_reports = response.data;
            this.$emit('setup-proposal', this.experiment_reports);
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.$notify({ type: 'warn', title: 'Could not load data' });
          });
      },
      go_to_experiment_report(item) {
        const proposalId = this.getId(item);
        this.$router.push(`/documents/${proposalId}/experiment_reports`);
      },
      change_page(val) {
        this.currentPage = val;
      },
      calculate_row_index(index) {
        return index + (this.perPage * (this.currentPage - 1));
      },
      download_as_zip() {
        this.zipLoading = true;
        this.axios({
          url: `${this.load_data_url}/pdf`,
          method: 'GET',
          responseType: 'blob',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'experiment_reports.zip');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            this.zipLoading = false;
          });
      },
      getAttachmentId(item) {
        return item.experiment_report?.attachments?.length > 0 ? item.experiment_report?.attachments[0] : '';
      },
      isReportSubmitted(item) {
        return item.experiment_report && item.experiment_report.states.name === 'submitted';
      },
    },
    created() {
      this.load_data();
    },
  };
</script>

<style scoped>
  ::v-deep .hidden-filters .b-table-top-row {
    display: none;
  }
</style>
